import './ToS.css';

function ToS() {
  return (
    <div className="tos">
      <section className="tos-hero">
        <div className="tos-hero-img">
          <img src="/assets/hero_img.png" alt="Hero Image" />
        </div>
        <div className="container">
          <h1>Terms of Use — Edict!</h1>
          <p className="hero-subtitle">Please read these terms carefully before using the app</p>
          <p className="last-updated">Effective Date: March 1, 2026 &nbsp;·&nbsp; Last Updated: March 1, 2026</p>
        </div>
      </section>

      <section className="tos-content">
        <div className="container">

          <div className="policy-section">
            <h2>1. Eligibility</h2>
            <p>
              You must be at least 13 years old to use Edict!. If you are under 18, you must have
              permission from a parent or legal guardian. By using the App, you represent that you
              meet these requirements.
            </p>
          </div>

          <div className="policy-section">
            <h2>2. User Accounts</h2>
            <p>
              You are responsible for maintaining the confidentiality of your account credentials.
              You agree to provide accurate information when creating an account and to notify us
              immediately of any unauthorized use. We reserve the right to terminate or suspend
              accounts at our sole discretion.
            </p>
          </div>

          <div className="policy-section">
            <h2>3. User-Generated Content</h2>
            <p>
              Edict! allows users to submit edicts, posts, comments, and other content in community
              dimensions ("User Content").
            </p>
            <p>
              You retain ownership of your User Content. By submitting it, you grant Small Robot LLC
              a worldwide, non-exclusive, royalty-free license to display, moderate, and distribute
              that content within the App.
            </p>
            <h3>Zero Tolerance Policy</h3>
            <p>
              We have zero tolerance for objectionable content or abusive users. You agree not to
              post, share, or transmit content that:
            </p>
            <ul>
              <li>Is obscene, pornographic, sexually explicit, or depicts minors in any sexual context</li>
              <li>Is threatening, harassing, or promotes violence against any individual or group</li>
              <li>Is defamatory, fraudulent, or intentionally misleading</li>
              <li>Promotes or facilitates illegal activity</li>
              <li>Violates another person's intellectual property, privacy, or other rights</li>
              <li>Is spam or unsolicited commercial messages</li>
            </ul>
            <p>
              Violations may result in immediate content removal and permanent account termination
              without notice or refund.
            </p>
          </div>

          <div className="policy-section">
            <h2>4. Content Moderation</h2>
            <p>We are committed to maintaining a safe environment. Our moderation policy:</p>
            <ul>
              <li>Users may flag any post or comment as objectionable using the in-app reporting feature</li>
              <li>Users may block other users at any time; blocked users are removed from your feed immediately</li>
              <li>We will review reported content and take action — including removal and user ejection — within 24 hours of a valid report</li>
              <li>Severe violations (CSAE, credible threats, illegal content) are reported to appropriate authorities immediately</li>
            </ul>
            <p>
              We reserve the right to remove any content and suspend or terminate any account at any
              time without prior notice if we believe it violates these Terms.
            </p>
          </div>

          <div className="policy-section">
            <h2>5. AI-Generated Content</h2>
            <p>
              Edict! uses artificial intelligence to generate news articles, images, audio, and video
              based on your inputs ("AI Content"). You acknowledge that:
            </p>
            <ul>
              <li>AI Content is fictional and generated for entertainment purposes only</li>
              <li>AI Content does not represent real events, real people, or factual reporting</li>
              <li>Small Robot LLC does not guarantee the accuracy, completeness, or quality of AI Content</li>
              <li>You may not use AI Content to deceive others or misrepresent it as factual</li>
            </ul>
          </div>

          <div className="policy-section">
            <h2>6. Subscriptions and In-App Purchases</h2>
            <h3>Mortal (Free Tier)</h3>
            <p>Basic access to Edict! features at no charge.</p>

            <h3>Demigod Subscription</h3>
            <p>
              Unlocks expanded features including increased edict frequency, additional content
              formats, and premium customization options. Billed monthly or annually as displayed
              at the time of purchase.
            </p>

            <h3>Omnigod Subscription</h3>
            <p>
              Full access to all Edict! features. Billed monthly or annually as displayed at the
              time of purchase.
            </p>

            <h3>Video Tokens</h3>
            <p>
              Consumable in-app purchases used to generate AI video content. Tokens are
              non-refundable once consumed.
            </p>

            <h3>Auto-Renewal</h3>
            <p>
              Subscriptions automatically renew unless cancelled at least 24 hours before the end
              of the current billing period. Your Apple ID will be charged upon confirmation of
              purchase and at the start of each renewal period.
            </p>

            <h3>Managing Subscriptions</h3>
            <p>
              You can manage or cancel your subscription at any time in your device's App Store
              subscription settings. Cancellation takes effect at the end of the current billing
              period — you will not receive a prorated refund for unused time.
            </p>

            <h3>Free Trials</h3>
            <p>
              If a free trial is offered, you will be charged the applicable subscription price at
              the end of the trial period unless you cancel before the trial ends.
            </p>

            <p>
              All billing is handled by Apple. For billing disputes or refund requests, contact{' '}
              <a href="https://reportaproblem.apple.com" target="_blank" rel="noopener noreferrer">
                Apple Support
              </a>.
            </p>
          </div>

          <div className="policy-section">
            <h2>7. Acceptable Use</h2>
            <p>You agree not to:</p>
            <ul>
              <li>Reverse engineer, decompile, or attempt to extract the source code of the App</li>
              <li>Use automated tools (bots, scrapers) to access or interact with the App</li>
              <li>Attempt to circumvent subscription or access controls</li>
              <li>Impersonate another person or entity</li>
              <li>Interfere with the App's infrastructure or other users' experience</li>
            </ul>
          </div>

          <div className="policy-section">
            <h2>8. Intellectual Property</h2>
            <p>
              All App content, design, branding, and AI systems are the property of Small Robot LLC
              and are protected by applicable intellectual property laws. Nothing in these Terms
              grants you a right to use our trademarks, logos, or branding.
            </p>
          </div>

          <div className="policy-section">
            <h2>9. Disclaimer of Warranties</h2>
            <p>
              The App is provided "as is" and "as available" without warranties of any kind, express
              or implied. We do not warrant that the App will be uninterrupted, error-free, or free
              of viruses. AI-generated content is provided for entertainment only and should not be
              relied upon as factual.
            </p>
          </div>

          <div className="policy-section">
            <h2>10. Limitation of Liability</h2>
            <p>
              To the maximum extent permitted by law, Small Robot LLC shall not be liable for any
              indirect, incidental, special, consequential, or punitive damages arising from your
              use of the App, even if advised of the possibility of such damages. Our total liability
              to you for any claim shall not exceed the amount you paid us in the 12 months preceding
              the claim.
            </p>
          </div>

          <div className="policy-section">
            <h2>11. Indemnification</h2>
            <p>
              You agree to indemnify and hold harmless Small Robot LLC and its officers, employees,
              and agents from any claims, damages, or expenses arising from your use of the App,
              your User Content, or your violation of these Terms.
            </p>
          </div>

          <div className="policy-section">
            <h2>12. Termination</h2>
            <p>
              We may suspend or terminate your access to the App at any time for any reason,
              including violation of these Terms. Upon termination, all licenses granted to you
              under these Terms will immediately cease. You may delete your account at any time
              from the Settings screen in the App.
            </p>
          </div>

          <div className="policy-section">
            <h2>13. Changes to These Terms</h2>
            <p>
              We may update these Terms from time to time. We will notify you of material changes
              through the App or by email. Continued use of the App after changes take effect
              constitutes your acceptance of the revised Terms.
            </p>
          </div>

          <div className="policy-section">
            <h2>14. Governing Law</h2>
            <p>
              These Terms are governed by the laws of the State of Missouri, without regard to
              conflict of law principles. Any disputes shall be resolved in the courts of Missouri.
            </p>
          </div>

          <div className="policy-section">
            <h2>15. Contact Us</h2>
            <p>
              If you have questions about these Terms, want to report a violation, or want to
              request account deletion, contact us at:
            </p>
            <p>
              Small Robot LLC<br />
              Email:{' '}
              <a href="mailto:support@smallrobot.app">support@smallrobot.app</a><br />
              Website:{' '}
              <a href="https://smallrobot.app" target="_blank" rel="noopener noreferrer">
                smallrobot.app
              </a>
            </p>
          </div>

        </div>
      </section>
    </div>
  );
}

export default ToS;
